"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isCheckedIndex = isCheckedIndex;
exports.isChecked = isChecked;
function isCheckedIndex(selectedValue, value) {
    return selectedValue.findIndex(function (x) {
        return x == value;
    });
}

function isChecked(selectedValue, value) {
    return isCheckedIndex(selectedValue, value) > -1;
}


//////////////////
// WEBPACK FOOTER
// ./~/@alicd/crui-checkbox/lib/util.js
// module id = 43
// module chunks = 0